export enum RepetitionUnitTypeEnum {
  Execution = 'Execution',
  Second = 'Second'
}
